import React from "react";

import { Context, fetchLesson } from "../../../teacherStore";
import { parseQueryParams } from "../../../libs/Util";
import MaterialForImage from "../../../templates/teacher/MaterialForImage";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const classListInParams = parseQueryParams()["classList"];
  const lesson = parseInt(parseQueryParams()["lesson"]);
  const classList = classListInParams
    .split(",")
    .map((classID: string) => Number(classID));

  React.useEffect(() => {
    dispatch(fetchLesson(lesson));
  }, [dispatch, lesson]);

  return state.lesson && state.lesson.id === lesson ? (
    <MaterialForImage
      lesson={state.lesson}
      classList={classList}
      nextLessonId={state.next_lesson_id}
      prevLessonId={state.prev_lesson_id}
    />
  ) : null;
};
